import { InputField } from '@app/components/various/Form';
import { isDefined } from '@app/utils/is';
import { Checkout, CheckoutForm } from '@typings';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Props {
  checkoutFields: Checkout.Requirements;
  isLoading: boolean;
}

export const CheckoutPoNumber = ({ checkoutFields, isLoading }: Props) => {
  const { poNumber } = checkoutFields;
  const { t } = useTranslation(['checkout', 'invoices']);
  const {
    register,
    formState: { errors },
  } = useFormContext<CheckoutForm>();

  if (!isDefined(poNumber)) {
    return null;
  }

  return (
    <div className="box">
      <div className="pb-2">
        <InputField
          {...register('poNumber')}
          isLoading={isLoading}
          isRequired={poNumber.required}
          isInvalid={isDefined(errors.poNumber)}
          data-testid="po-number-input"
          placeholder={t('checkout:po_number_placeholder')}
          label={t('checkout:po_number')}
          maxLength={40}
        />
      </div>
    </div>
  );
};
